export default __webpack_public_path__ + "a9e8a8ac7f2dd7e2c002f2576786a39d.png";